import { render, staticRenderFns } from "./ShowMultiChars.vue?vue&type=template&id=f90ea61e"
import script from "./ShowMultiChars.vue?vue&type=script&lang=js"
export * from "./ShowMultiChars.vue?vue&type=script&lang=js"
import style0 from "./styles/index.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports